export default {
    'Watch': {title: 'Watch', icon: 'icon-watch'},
    'Unwatch': {title: 'Unwatch', icon: 'icon-unwatch'},
    'Download': {title: 'Download', icon: 'icon-download'},
    'DownloadFolder': {title: 'Download', icon: 'icon-download'},
    'View': {title: 'View', icon: 'icon-view'},
    'Delete': {title: 'Delete', icon: 'icon-clear'},
    'DeletePermanently': {title: 'Delete Permanently', icon: 'icon-clear'},
    'Copy': {title: 'Copy', icon: 'icon-copy'},
    'Move': {title: 'Move', icon: 'icon-move'},
    'CopyStash': {title: 'Copy Stash to Repository', icon: 'icon-copy'},
    'MoveStash': {title: 'Move Stash to Repository', icon: 'icon-move'},
    'ShowInTree': {title: 'Show In Tree', icon: 'icon-show-in-tree'},
    'DiscardFromStash': {title: 'Discard from Stash', icon: 'icon-delete-content'},
    'DiscardStash': {title: 'Discard Search Results', icon: 'icon-delete-content'},
    'DeleteContent': {title: 'Delete Content', icon: 'icon-clear'},
    'CopyContent': {title: 'Copy Content', icon: 'icon-copy'},
    'MoveContent': {title: 'Move Content', icon: 'icon-move'},
    'DeleteVersions': {title: 'Delete Versions', icon: 'icon-delete-versions'},
    'Refresh': {title: 'Refresh', icon: 'icon-refresh'},
    'UploadToBintray': {title: 'Push to Bintray', icon: 'icon-bintray'},
    'Distribute': {title: 'Distribute to Bintray', icon: 'icon-distribution-repo'},
    'Redistribute': {title: 'Redistribute', icon: 'icon-distribution-repo'},
    'Zap': {title: 'Zap Cache', icon: 'icon-zap'},
    'ZapCaches': {title: 'Zap Caches', icon: 'icon-zap'},
    'RecalculateIndex': {title: 'Recalculate Index', icon: 'icon-re-index'},
    'NativeBrowser': {title: 'Native Browser', icon: 'icon-simple-browser'},
    'EmptyTrash': {title: 'Empty Trash Can', icon: 'icon-trash'},
    'SearchTrash': {title: 'Search Trash Can', icon: 'icon-search'},
    'Restore': {title: 'Restore', icon: 'icon-trashcan-restore'},
    'IgnoreAlert': {title: 'Ignore Alert', icon: 'icon-xray-ignore-alert'},
    'UnignoreAlert': {title: 'Un-Ignore Alert', icon: 'icon-xray-alert'},
    'Favorites': {title: 'Add to Favorites', icon: 'icon-star'}
};


// WEBPACK FOOTER //
// ./constants/artifacts_actions.constants.js